module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bf01dc918ea2dcb213fee7dad6e48245.png";